<template>
  <div class="columns is-block response-rate">
    <!-- Response header Begins -->
    <div class="column has-text-centered is-full" v-if="internalAttributes.header.show">
      <span class="response-rate-percentage">
        <div class="columns is-flex-mobile divider">
          <div class="column has-text-left bold-text">
            {{internalAttributes.header.title}}
          </div>
          <div class="column has-text-right bold-percentage">
            <animated-number
              round="1"
              :duration="500"
              :formatValue="formatStats"
              :value="calculateRatesBreakdown(responseRates.avgResponseCount)"
            />%
          </div>
        </div>
      </span>
    </div> <!-- Response header Ends -->
    <!-- Time to reply Begins -->
    <div class="column has-text-centered is-full average-reply-section" v-if="internalAttributes.avgReply.show">
      <div class="columns is-flex-mobile">
        <div class="column has-text-left">
          {{internalAttributes.avgReply.title}}
        </div>
        <div class="column has-text-right bold-hours">
          {{formatStats(responseRates.avgReplyTime)}} <span class="hours">{{internalAttributes.avgReply.hoursString}}</span>
        </div>
      </div>
    </div> <!-- Time to reply Ends -->
    <!-- Response Rate Breakdown Begins -->
    <div class="column rate-breakdown">
      <div class="columns is-flex-mobile margin-0 has-text-right-desktop has-text-centered-mobile" v-for="response in responseRates.intervalBreakdown">
        <div class="column is-2 is-1-mobile">
          <p class="percent">
            <animated-number
              round="1"
              :duration="500"
              :value="calculateRatesBreakdown(response.count)"
              :formatValue="formatStats"
            ></animated-number>%
          </p>
        </div>
        <div class="column is-7">
          <p class="is-size-7">
            <progress
              max="100"
              :value="calculateRatesBreakdown(response.count)"
              :class="['progress is-basic', { 'is-small': true }]"
            >
              {{calculateRatesBreakdown(response.count)}}&#37;
            </progress>
          </p>
        </div>
        <div class="column is-3-mobile has-text-left interval">
          <p>{{response.interval}}</p>
        </div>
      </div>
    </div> <!-- Response Rate Breakdown Ends -->
  </div>
</template>

<script>
  import AnimatedNumber from 'animated-number-vue'

  export default {
    name: 'ResponseRateWidget',
    components: {
      AnimatedNumber
    },
    props: {
      responseRates: {
        type: Object,
        required: true
      },
      attributes: {
        type: Object,
        default: () => ({})
      }
    },
    computed: {
      /**
       * Compute internal attributes
       * @return {Object}
       */
      internalAttributes () {
        return Object.assign({
          header: {
            show: true,
            title: 'Response rate'
          },
          avgReply: {
            show: true,
            title: 'Average time to reply',
            hoursString: 'HOURS'
          }
        }, this.attributes)
      }
    },
    methods: {
      /**
       * Format the float numbers upto two digits after decimal
       * @param {Number|String} value Value of stat
       * @return {Number|String}
       */
      formatStats (value) {
        if (isNaN(value)) {
          return 0
        }
        return !Number.isInteger(value) ? `${Number(value).toFixed(2)}` : value
      },
      /**
       * Calculate the rates for breakdown
       * @param {number} value Value of stat
       * @return {number}
       */
      calculateRatesBreakdown (value) {
        let rate = (value * 100) / this.responseRates.totalReviews
        return !isNaN(rate) ? rate : 0
      }
    }
  }
</script>

<style lang="scss" scoped>
  $text-color: #58595b;

  .response-rate {
    border: solid 1px rgba(88, 89, 91, 0.32);
    padding: 0 12px 15px 12px;

    .column {
      margin: auto 0;
      padding: 0;
    }
  }
  .response-rate-percentage {
    color: $text-color;

    div {
      padding: 0 0 8px 0;
    }
    p {
      font-size: 10px !important;
      width: 20px;
      text-align: right;
    }
    .divider {
      border-bottom: 1px solid #dbdbdb;
      margin-bottom: 0 !important;
      padding: 10px 0 !important;
    }
    .bold-text {
      font-size: 12px;
      font-weight: bold;
    }
    .bold-percentage {
      font-size: 18px;
      font-weight: bold;
    }
  }
  .response-progress-bar progress{
    margin: 0 8px !important;

    progress{
      width: 167.8px;
      height: 10.9px;
      border-radius: 0;
    }
  }
  .response-time p {
    font-size: 10px;
    color: $text-color;
  }
  .response-rate-progress {
    margin: 0;
  }
  .average-reply-section {
    color: $text-color;
    padding: 12px 0 !important;
    font-size: 12px;

    .bold-hours {
      font-size: 18px;
      font-weight: bold;

      .hours {
        font-size: 12px;
      }
    }
  }
  .rate-breakdown {
    color: $text-color;
    margin: 12px 0 0 !important;
    font-size: 10px;

    .is-2 {
      width: 10%;
      margin-right: 10px;
    }
    .is-7 {
      width: 53%;
    }
    .interval {
      padding: 0 0 0 10px;
    }
    .progress {
      height: 10.9px;
      border-radius: 0;
    }
  }
  .progress::-webkit-progress-value {
    transition: width 0.8s ease;
  }
  .progress.is-basic::-webkit-progress-value {
    background-color: #2fabe1;
  }
  .progress.is-basic::-moz-progress-bar {
    background-color: #2fabe1;
  }
  .progress.is-basic::-ms-fill {
    background-color: #2fabe1;
  }
  /* Helper css begins */
  .margin {
    &-0 {
      margin: 0;
    }
  }
  /* Helper css ends */
</style>



// WEBPACK FOOTER //
// src/widgets/home/ResponseRateWidget.vue